// DualcamViewerBackend URL, used by the dowtex frontend's DualCam pages/API client.
//
// Resolved at module load, in this order:
//   1. window.__RUNTIME_CONFIG__.DUALCAM_BACKEND_URL - injected at container startup by
//      docker-entrypoint.sh from the DOWTEX_DUALCAM_BACKEND_URL env var. This is what lets
//      the same built image be pointed at production/staging/snapshot without a rebuild.
//   2. process.env.REACT_APP_DOWTEX_DUALCAM_BACKEND_URL - CRA build-time override. This is
//      what `npm start` and any build that doesn't go through the container entrypoint
//      use; set it in a local .env file for local dev against a non-default backend.
//   3. Hardcoded production URL below - the fallback when neither is set.
//
// This is deliberately independent from ../grpcConfig.ts (the Saufdings login backend) -
// dowtex has two separate backend URLs to configure, and mixing them up would send
// DualCam requests to the login backend or vice versa.
//
// An empty string from either source counts as "not set" (falls through), so a
// misconfigured deployment can never end up silently pointed at a garbage empty URL -
// worst case it falls all the way through to production.
//
// A container started with no DOWTEX_DUALCAM_BACKEND_URL set points at production.

import { runtimeValue } from '@dowty/core';

const PRODUCTION_DUALCAM_BACKEND_URL = 'https://dualcamapi.dowtex.com';

function resolveDualcamBackendUrl(): string {
  const runtimeUrl = runtimeValue('DUALCAM_BACKEND_URL');
  if (runtimeUrl) {
    return runtimeUrl;
  }

  const buildTimeUrl = process.env.REACT_APP_DOWTEX_DUALCAM_BACKEND_URL;
  if (buildTimeUrl) {
    return buildTimeUrl;
  }

  return PRODUCTION_DUALCAM_BACKEND_URL;
}

const DUALCAM_BACKEND_URL = resolveDualcamBackendUrl();
export default DUALCAM_BACKEND_URL;
